import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

/** Shared legal-page wrapper — keeps every policy visually consistent. */
export function LegalPage({ title, lastUpdated, children, testId }) {
  return (
    <div className="min-h-screen bg-black text-white">
      <header className="border-b border-white/5 px-6 md:px-12 py-5 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2 font-display text-xl font-medium">
          <img src="/beatcredsi-mark.png" alt="" width={44} height={44} />
          BeatCred<span className="text-amber-500">si</span><span className="text-amber-500 text-xs align-super">™</span>
        </Link>
        <Link to="/" className="text-xs text-neutral-400 hover:text-white inline-flex items-center gap-1.5">
          <ArrowLeft size={12} /> Home
        </Link>
      </header>
      <main className="max-w-3xl mx-auto px-6 md:px-12 py-16">
        <div className="text-overline mb-3">Legal</div>
        <h1 className="font-display text-4xl sm:text-5xl font-medium tracking-tight mb-3" data-testid={testId}>{title}</h1>
        <div className="font-mono-tech text-xs text-neutral-500 mb-12">Last Updated: June 2026</div>
        <div className="space-y-10 text-sm text-neutral-300 leading-relaxed">{children}</div>
        <LegalNav />
      </main>
    </div>
  );
}

export function Section({ title, children }) {
  return (
    <section>
      <h2 className="font-display text-xl text-amber-500 mb-3">{title}</h2>
      <div className="space-y-3 [&_ul]:list-disc [&_ul]:pl-6 [&_ul]:space-y-1.5 [&_a]:underline">{children}</div>
    </section>
  );
}

function LegalNav() {
  const links = [
    { to: "/terms",   label: "Terms of Service" },
    { to: "/privacy", label: "Privacy Policy" },
    { to: "/refunds", label: "Refund Policy" },
    { to: "/cookies", label: "Cookie Policy" },
    { to: "/aup",     label: "Acceptable Use Policy" },
  ];
  return (
    <nav className="mt-16 pt-8 border-t border-white/5 flex flex-wrap gap-x-6 gap-y-2 text-xs text-neutral-400">
      {links.map((l) => (
        <Link key={l.to} to={l.to} className="hover:text-amber-500" data-testid={`legal-nav-${l.to.slice(1)}`}>
          {l.label}
        </Link>
      ))}
    </nav>
  );
}
